import React from 'react';
import { BottomNavigation, BottomNavigationAction, Tabs, Tab, Hidden, Badge } from '@material-ui/core';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import Procesos from '@material-ui/icons/ImportContacts';
import CreateIcon from '@material-ui/icons/Create';
import Notificaciones from '@material-ui/icons/NotificationImportant';
import PracticasNotificaciones from './PracticasNotificaciones';
import Instructivo from '@material-ui/icons/LocalLibrary';

export default function MenuEstudiantePracticas({ notificaciones, sele = 0, seleccionar = () => { }, instructivo }) {

  const clase = (item, selec, tipo = '') => item === selec ? `item_selec${tipo}` : `item_modulo`;

  const pintar = (app, claseN = '') => {
    if (!app) {
      return (
        <div className={claseN}>
          <BottomNavigation showLabels className={clase('proceso', sele)} onClick={() => seleccionar('proceso')}>
            <BottomNavigationAction label={'Proceso'} icon={<LocationOnIcon />} />
          </BottomNavigation>
          <PracticasNotificaciones notificaciones={notificaciones} render={(click) => <BottomNavigation showLabels onClick={click} className={clase('notificaciones', sele)} ><BottomNavigationAction label={'Notificación'} icon={<Badge badgeContent={notificaciones.length} color="secondary"><Notificaciones /></Badge>} />  </BottomNavigation>} />
          <BottomNavigation showLabels className={clase('agregar', sele)} onClick={() => seleccionar('agregar')}>
            <BottomNavigationAction label={'Nuevo'} icon={<CreateIcon />} />
          </BottomNavigation>
          <BottomNavigation showLabels className={clase('historial', sele)} onClick={() => seleccionar('historial')}>
            <BottomNavigationAction label={'Historial'} icon={<Procesos />} />
          </BottomNavigation>
          <BottomNavigation showLabels className={clase('instructivo', sele)} onClick={() => window.open(instructivo, '_blank')}>
            <BottomNavigationAction label={'Instructivo'} icon={<Instructivo />} />
          </BottomNavigation>
        </div>
      )
    } else {
      return (
        <div className={claseN}>
          <Tabs value={sele} variant="fullWidth" scrollButtons="off" >
            <Tab label={'Proceso'} icon={<LocationOnIcon className='menu_icono' />} className={clase('proceso', sele, '_app')} value='proceso' onClick={() => seleccionar('proceso')} />
            <PracticasNotificaciones notificaciones={notificaciones} horizontal='left' render={(click) => <Tab onClick={click} label={'Notificación'} icon={<Badge badgeContent={notificaciones.length} color="secondary"><Notificaciones /></Badge>} className={clase('notificaciones', sele, '_app')} value='notificaciones' />} />
            <Tab label={'Nuevo'} icon={<CreateIcon className='menu_icono' />} className={clase('agregar', sele, '_app')} value='agregar' onClick={() => seleccionar('agregar')} />
            <Tab label={'Historial'} icon={<Procesos className='menu_icono' />} className={clase('historial', sele, '_app')} value='historial' onClick={() => seleccionar('historial')} />
          </Tabs>
        </div>
      )
    }
  }



  return (
    <div>
      <div>
        <Hidden xsDown> {pintar(false, 'menu_modulo')} </Hidden>
        <Hidden smUp> {pintar(true, 'menu_modulo_app')}</Hidden>
      </div>
    </div>
  );
}
